import React from 'react';
import { Box, MenuItem, TextField } from '@mui/material';
import { searchSummary } from '../common/form/MobileFilterCollapse';
import SearchCard, { fieldProps } from '../common/list/SearchCard';
import MobileSearchAdornment from '../common/search/MobileSearchAdornment';

// 제품정보(/productmng) 검색 영역 - chancemng 설계(fc30533) 적용(2026-10-22).
// 추가/엑셀 다운로드/엑셀 업로드 버튼은 breadcrumb action으로 옮겼다(ProductListContainer).
export const ProductListBox = ({ formik, onReset }) => {
  return (
    <SearchCard
      summary={searchSummary(formik.values)}
      onSubmit={formik.handleSubmit}
      onReset={onReset}
      submitting={formik.isSubmitting}
      gridSx={{
        gridTemplateAreas: {
          xs: `"keyword" "search" "btns"`,
          sm: `"keyword search btns"`,
        },
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'minmax(160px, 0.8fr) minmax(200px, 1.2fr) 190px',
        },
      }}
    >
      {/* 검색키워드 */}
      <Box sx={{ gridArea: 'keyword', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          select
          fullWidth
          required
          id="searchKeyword"
          name="searchKeyword"
          label="검색키워드"
          value={formik.values.searchKeyword}
          onChange={formik.handleChange}
          error={formik.touched.searchKeyword && Boolean(formik.errors.searchKeyword)}
          helperText={formik.touched.searchKeyword && formik.errors.searchKeyword}
        >
          <MenuItem value="">검색키워드</MenuItem>
          <MenuItem value="partnerNm">제조사</MenuItem>
          <MenuItem value="productLine">제품군</MenuItem>
          <MenuItem value="productNm">제품명</MenuItem>
          <MenuItem value="modelNm">모델명</MenuItem>
          <MenuItem value="category">아이템명</MenuItem>
        </TextField>
      </Box>

      {/* 검색어 */}
      <Box sx={{ gridArea: 'search', minWidth: 0 }}>
        <TextField
          {...fieldProps}
          fullWidth
          required
          id="searchWords"
          name="searchWords"
          label="검색어"
          value={formik.values.searchWords || ''}
          onChange={formik.handleChange}
          error={formik.touched.searchWords && Boolean(formik.errors.searchWords)}
          helperText={formik.touched.searchWords && formik.errors.searchWords}
          InputProps={{
            endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
          }}
        />
      </Box>
    </SearchCard>
  );
};
